import React from 'react'
import DashboardInner from './DashboardInner'

function DashboardController() { return ( <DashboardInner /> ) }

export default React.memo(DashboardController)
